import { useQuery } from '@apollo/client/react'
import { BoxProps } from '@chakra-ui/react'
import { CommentList, CommentListProps } from '@src/components/sco/Comments/CommentList'
import { QueryContainer } from '@src/components/sco/QueryContainer'
import gql from 'fraql'
import { ReactNode } from 'react'

export type CommentThreadProps = {
  attachmentId?: string
  attachmentType?: string
  collapseComments?: boolean
  composerBoxProps?: BoxProps
  isScrollable?: boolean
  innerPadding?: BoxProps['padding']
  maxHeight?: BoxProps['height']
  replyDepthLimit?: number
  showReplies?: boolean
  showBottomComposer?: boolean
  showTopComposer?: boolean
  showFixedComposer?: boolean
  threadId?: string
  renderBlankState?: () => ReactNode
  composerPlaceholder?: string
  commentListProps?: CommentListProps
  threadTypeKey?: string
}

export const CommentThread = (props: CommentThreadProps) => {
  const query = useQuery(CommentThread.queries.thread(), {
    variables: {
      attachmentType: props.attachmentType,
      attachmentId: props.attachmentId,
      threadId: props.threadId,
      threadTypeKey: props.threadTypeKey,
    },
  })

  // console.log(props.attachmentType, props.attachmentId)

  return (
    <>
      <QueryContainer
        dataIsValid={data => !!data?.forum?.thread?.threadId}
        query={query}
        renderData={data => (
          <CommentList
            attachmentType={props.attachmentType}
            composerBoxProps={props.composerBoxProps}
            composerPlaceholder={props.composerPlaceholder}
            innerPadding={props.innerPadding}
            isScrollable={props.isScrollable}
            maxHeight={props.maxHeight}
            renderBlankState={props.renderBlankState}
            showBottomComposer={props.showBottomComposer}
            showFixedComposer={props.showFixedComposer}
            showReplies={props.showReplies}
            showTopComposer={props.showTopComposer}
            threadId={data.forum.thread.threadId}
            {...props.commentListProps}
          />
        )}
      />
    </>
  )
}

CommentThread.queries = {
  thread: () => gql`
    query ($attachmentId: String, $attachmentType: String, $threadId: String, $threadTypeKey: String) {
      forum {
        id
        thread(
          attachmentId: $attachmentId
          attachmentType: $attachmentType
          threadId: $threadId
          threadTypeKey: $threadTypeKey
        ) {
          ${CommentThread.fragments.ScoThread()}
        }
      }
    }
  `,
}

CommentThread.fragments = {
  ScoThread: () => gql`
    fragment _ on ScoThread {
      id
      attachmentId
      attachmentType
      threadId
    }
  `,
}
